import React from "react";
import { Camera, Sparkles } from "lucide-react";

/** Egyetlen AI háttér — backend ugyanezt a referenciaképet használja. */
export const AI_BG_PRESET_KEY = "concrete_studio";

export const AI_BG_PRESETS = [
  {
    key: AI_BG_PRESET_KEY,
    label: "Beton stúdió",
    desc: "Beton stúdió — élethű fényezés, üvegen stúdió (nem matt CGI)",
    Icon: Camera,
  },
];

const PREVIEW_SRC = "/ai-bg/concrete-studio.png";

const USAGE_KEY = "autopark_aibg_preset_usage_v1";

export function bumpAiBgPresetUsage(presetKey) {
  try {
    const u = JSON.parse(localStorage.getItem(USAGE_KEY) || "{}");
    u[presetKey || AI_BG_PRESET_KEY] = (u[presetKey || AI_BG_PRESET_KEY] || 0) + 1;
    localStorage.setItem(USAGE_KEY, JSON.stringify(u));
  } catch (_) {}
}

/** Egy fix háttér előnézete — nincs más választék. */
export function AiBgPresetSelector({ testidPrefix = "aibg-preset" }) {
  const { label, desc } = AI_BG_PRESETS[0];

  return (
    <div
      className="rounded-xl overflow-hidden border border-electric/40 ring-2 ring-electric/25 bg-anthracite-800"
      data-testid={`${testidPrefix}-grid`}
    >
      <div className="relative aspect-[16/10]">
        <img
          src={PREVIEW_SRC}
          alt={label}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
        <div className="absolute top-2 right-2 inline-flex items-center gap-1 px-2 py-1 rounded-full bg-electric/90 text-[10px] uppercase tracking-widest text-white">
          <Sparkles className="w-3 h-3" strokeWidth={2} />
          AI háttér
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <div className="flex items-center gap-2">
            <Camera className="w-4 h-4 text-electric" strokeWidth={1.75} />
            <div className="text-sm font-medium text-white">{label}</div>
          </div>
          <p className="text-[11px] text-slate-300 mt-1 leading-snug">{desc}</p>
        </div>
      </div>
    </div>
  );
}
